import { Link, useLocation } from "react-router-dom";

import { useAuth } from "../auth/useAuth";
import { MARKETING_URL } from "../config";

/**
 * NavBar — Task 9.9. Persistent navigation across pages. Paid-only
 * destinations show a lock hint for free users (they route to /upgrade).
 */

interface NavItem {
  label: string;
  to: string;
  paidOnly?: boolean;
}

const ITEMS: NavItem[] = [
  { label: "Home", to: "/" },
  { label: "Saved", to: "/saved", paidOnly: true },
  { label: "Compare", to: "/compare", paidOnly: true },
  { label: "Alerts", to: "/alerts", paidOnly: true },
  { label: "Account", to: "/account" },
];

export function NavBar() {
  const auth = useAuth();
  const location = useLocation();
  const isPaid = auth.tier === "paid";

  return (
    <nav className="nav-bar" aria-label="Primary">
      {/* Task 9.9a: the wordmark links to the marketing site (not the app
          home), matching PriceTilt.com branding. Env-aware (config.ts) so the
          dev app points at staging, prod at www. */}
      <a
        href={`${MARKETING_URL}/`}
        className="nav-brand"
        aria-label="PriceTilt home"
      >
        PriceTilt<span className="nav-brand-mark" aria-hidden />
      </a>
      <ul className="nav-items">
        {ITEMS.map((item) => {
          const locked = item.paidOnly && !isPaid;
          const active = location.pathname === item.to;
          return (
            <li key={item.to}>
              <Link
                to={locked ? "/upgrade" : item.to}
                className={`nav-link${active ? " nav-link-active" : ""}${locked ? " nav-link-locked" : ""}`}
                title={locked ? "PriceTilt Pro feature — upgrade to unlock" : undefined}
              >
                {item.label}
                {locked && <span className="nav-lock" aria-hidden> 🔒</span>}
              </Link>
            </li>
          );
        })}
      </ul>
      {/* Sign out lives on the Account page now, not the NavBar — cleaner nav,
          less accidental sign-out (feature facebook-login-branded-auth, Req 5.1). */}
    </nav>
  );
}
